import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { formatDistance, formatDuration } from '../../../services/format-route';
import { PlannerStore } from '../../../services/planner-store';

@Component({
  selector: 'app-plan-summary',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './plan-summary.component.html',
  styleUrl: './plan-summary.component.css',
})
export class PlanSummaryComponent {
  private readonly store = inject(PlannerStore);

  readonly stopCount = computed(() => this.store.stops().length);

  readonly countLabel = computed(() => {
    const n = this.stopCount();
    if (n === 1) return '1 mesto';
    if (n >= 2 && n <= 4) return `${n} mesta`;
    return `${n} mesta`;
  });

  readonly distanceLabel = computed(() => {
    const s = this.store.routeSummary();
    if (!s) return null;
    return formatDistance(s.distanceMeters);
  });

  readonly durationLabel = computed(() => {
    const s = this.store.routeSummary();
    if (!s) return null;
    return formatDuration(s.durationSeconds);
  });
}
